import { FETCH_DEFERRED_START, FETCH_DEFERRED_SUCCESS, FETCH_DEFERRED_ERROR } from '../../../../actions/actions';

const fetchDeferredStart = (state, action) => {
  const componentId = action.component || 'html_description';
  return {
    ...state,
    components: {
      ...state.components,
      [componentId]: {
        ...state.components[componentId],
        fetched: true,
      },
    },
  };
};

const fetchDeferredSuccess = (state, action) => {
  const componentId = action.payload?.componentId || 'html_description';
  return {
    ...state,
    components: {
      ...state.components,
      [componentId]: {
        ...action.payload?.components[componentId],
        fetched: true,
      },
    },
    error: null,
  };
};

const fetchDeferredError = (state, action) => {
  const componentId = action.component || 'html_description';
  return {
    ...state,
    [componentId]: {
      fetched: false,
    },
    error: action.error,
  };
};

const fetchDeferredMapper = {
  [FETCH_DEFERRED_START]: fetchDeferredStart,
  [FETCH_DEFERRED_SUCCESS]: fetchDeferredSuccess,
  [FETCH_DEFERRED_ERROR]: fetchDeferredError,
};

export { fetchDeferredStart, fetchDeferredSuccess, fetchDeferredError };
export default fetchDeferredMapper;
